import { axiosAjax } from '@app/src/config/axios';
import { isClientEnv } from '@app/src/utils/validations';

export const serviceUserMessage = {
  async get(): Promise<any[]> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(process.env.API_HEADBAND_STEP_TWO, config);
      if (data.error) {
        throw new Error();
      }
      return data.data;
    } catch (e) {
      console.log('Error from services');
      throw new Error(e);
    }
  }
}
